<template>
	<div>
		<div style="height: 180px;">
			<div style="width: 115px;margin: auto;">
				<a-avatar v-if="avatar == ''" :size="100" icon="user" />
				<a-avatar v-else :size="100" :src="avatar" />
			</div>
			<div style="width: 70px;margin: auto;margin-top: 20px;font-size: 18px;font-weight: bold;">
				{{username}}
			</div>
			<div style="width: 170px;margin: auto;margin-top: 30px;font-size: 14px;font-weight: 600;">
				平台账号:{{account}}
			</div>
		</div>
		<div>
			<a-menu mode="inline" :defaultOpenKeys="['商铺管理','订单管理','营销管理']" :default-selected-keys="['经营数据']" :default-open-keys="['经营数据']" :style="{ height: '100%', borderRight: 0 }" @click="titleClick">
				<a-menu-item key="经营数据">
					<a-icon type="home" />
					经营数据
				</a-menu-item>
				<a-menu-item key="工厂信息">
					<a-icon type="build" />
					工厂信息
				</a-menu-item>
				
				<template slot="title">
				  <span>工厂信息审核通过后方可发布商品 ！</span>
				</template>
				<!--  :disabled="ischeckPass" -->
				<a-sub-menu key="商铺管理">
					<span slot="title">
						<a-icon type="setting" />
						<span>商铺管理</span>
					</span>
					<a-menu-item key="商品分类">
						<a-icon type="bars" />
						商品分类
					</a-menu-item>
					
						<a-menu-item key="添加商品" :disabled="ischeckPass">
							<a-tooltip>
							    <template slot="title" v-if="ischeckPass">
									工厂信息审核通过之后可添加商品！
							    </template>
							<a-icon type="shopping-cart" />
							添加商品
								</a-tooltip>
						</a-menu-item>
				
					<a-menu-item key="商品管理">
						<a-icon type="shop" />
						商品管理
					</a-menu-item>
				</a-sub-menu>
				
				<a-sub-menu key="订单管理">
					<span slot="title">
						<a-icon type="setting" />
						<span>订单管理</span>
					</span>
					<a-menu-item key="订单列表">
						<a-icon type="account-book" />
						订单列表
					</a-menu-item>
					<!-- <a-menu-item key="订单设置">
						<a-icon type="setting" />
						订单设置
					</a-menu-item> -->
					<a-menu-item key="退货申请处理">
						<a-icon type="history" />
						退货申请处理	
					</a-menu-item>
				</a-sub-menu>
				<a-sub-menu key="营销管理">
					<span slot="title">
						<a-icon type="setting" />
						<span>营销管理</span>
					</span>
					<a-menu-item key="广告列表">
						<a-icon type="account-book" />
						广告列表
					</a-menu-item>
				</a-sub-menu>
				<!-- <a-menu-item key="联系方式">
					<a-icon type="idcard" />
					联系方式
				</a-menu-item>
				<a-menu-item key="店铺客服">
					<a-icon type="calendar" />
					店铺客服
				</a-menu-item> -->
				<a-menu-item key="用户评价">
					<a-icon type="calendar" />
					用户评价
				</a-menu-item>
			</a-menu>
		</div>
		
	</div>
</template>

<script>
	import api from '../api/Api.js';
	
export default {
	data() {
		return {
			username:localStorage.getItem('username'),
			avatar:localStorage.getItem('avatar'),
			account:localStorage.getItem('phone'),
			ischeckPass: false
		};
	},
	mounted() {
		this.storeCheckStatus()
		this.sendData("经营数据");
		console.log("====================================")
		console.log(localStorage.getItem('username'));
		console.log("====================================")
	},
	methods: {
		titleClick(item, key, keyPath) {
			this.sendData(item.key)
		},
		sendData(key) {
			this.$emit('StoreMenuClick', key);
		},
		storeCheckStatus() {
			const that = this;
			let url = 'api/store/v1/admin/order/storeCheckStatus';
			let parm = '1';
			api.postRequest(url, parm, res => {
				if (res.data.status == 200) {
					if(res.data.data != "PASS"){
						that.ischeckPass = true;
					}
				} else {
					this.$message.error(res.data.message);
				}
			});
		},
	}
};
</script>

<style></style>
